export default __webpack_public_path__ + "static/media/Logo02.e5ed4498.png";